import { Component, OnInit } from '@angular/core';
import { LambdaService } from 'src/app/lambda.service';
import { SettingsService } from 'src/app/settings.service';
import { ThemingService } from 'src/app/theming.service';
declare let $: any;

@Component({
  selector: 'app-client-subscriptions',
  templateUrl: './client-subscriptions.component.html',
  styleUrls: ['./client-subscriptions.component.scss']
})
export class ClientSubscriptionsComponent implements OnInit {

  clientSubscriptions: any[] = [];
  searchString: string = '';
  loading: boolean = false;
  modalDelete = false;
  subscriptionIdToDelete: any;


  constructor(
    private themingService: ThemingService,
    public lambdaService: LambdaService,
    private settingsService: SettingsService
  ) { }

  ngOnInit(): void {
    this.getSubscriptions();
  }

  setCreatingSubscription(){
    this.settingsService.setCreatingSubscription();
  }

  setEditingSubscription(subscriptionId: string){
  this.settingsService.setEditingSubscription(subscriptionId);
  }

  deteleSubscription(response: number) {
    if (response) {
      this.loading = true;
      this.lambdaService.deleteClientSubscription(this.themingService.shopId, this.subscriptionIdToDelete)
        .then((data) => {
          this.getSubscriptions();
          $('#deleteSubscriptionModal').modal('show');
          this.loading = false;
        })
        .catch((error) => {
          console.error(error);
          this.loading = false;
        });
    }
    this.modalDelete = false;
  }

  closeModal(){
    $('#deleteSubscriptionModal').modal('hide');
  }

  async getSubscriptions() {
    this.loading = true;
    try {
      let response: any = await this.lambdaService.getClientSubscriptions(this.themingService.shopId);
      this.clientSubscriptions = response.subscriptions;
      this.loading = false;
    } catch (error) {
      console.error(error);
      this.loading = false;
    }
  }

}
